export default "__VITE_ASSET__DBJG$mMi__"